import { createColumnHelper } from '@tanstack/react-table';
import { cloneDeep } from 'lodash';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import { useProgress } from '@/contexts/ProgressProvider';

import FuelTable from '../../../components/fuel-table/FuelTable';
import { Permission } from '../../../enums';
import type { Pagination } from '../../../models';
import type { FuelEntityType } from '../../../services';
import { fuelUserAccessSliceSelector } from '../../../store/slices/fuelUserAccess';

interface Iprops {
  entity: FuelEntityType;
  items: [];
  columnName: string;
  goToPage: (event, item) => void;
}

const initialAssociatedChannelsPagination = {
  sortBy: 'name',
  descending: true,
  rowsPerPage: 100,
  page: 1,
  totalItems: 0,
  pages: 1,
};
const columnHelper = createColumnHelper<any>();

const TabPanelContainer = ({ entity, items, columnName, goToPage }: Iprops) => {
  const { permissions, fuelUserAccessData } = useSelector(fuelUserAccessSliceSelector);
  const [associatedChannelsPagination, setAssociatedChannelsPagination] = useState<Pagination>(
    initialAssociatedChannelsPagination
  );
  const navigate = useNavigate();
  const { loading } = useProgress();

  const clipUsersCloumns = [
    columnHelper.accessor('name', {
      align: 'left',
      header: () => 'Name',
      width: 500,
      sortable: true,
      cell: (cell) => {
        // console.log('cell', cell)
        return (
          <div
            title={cell.getValue()}
            className={permissions && permissions.has(Permission.EditAsset) ? 'clickable' : 'no-clickable'}
            onClick={(event) => onTableAction(event, 'goToEntity', cell.row.original, cell.table, cell.row.index)}
          >
            <span>{cell.getValue()}</span>
          </div>
        );
      },
    }),
  ];

  const onTableAction = async (event, type, item: any, context: any, index: number) => {
    goToPage(event, item);
  };
  const updatePagination = (totalItems) => {
    const paginationObj = cloneDeep(initialAssociatedChannelsPagination);
    paginationObj.totalItems = totalItems;
    paginationObj.pages = Math.ceil(paginationObj.totalItems / paginationObj.rowsPerPage);
    setAssociatedChannelsPagination(paginationObj);
  };
  const onPaginationChange = (paginationDetail: Pagination) => {
    // console.log('associatedChannelsPaginationChange');
    const paginationObj = cloneDeep(paginationDetail);
    setAssociatedChannelsPagination(paginationObj);
  };
  useEffect(() => {
    if (items.length > 0) {
      updatePagination(items.length);
    } else {
      updatePagination(0);
    }

    // console.log('items', {columnName, items, clipUsersCloumns})
  }, [items]);

  return (
    <div style={{ height: '60vh' }}>
      {columnName && (
        <FuelTable
          columnHelper={columnHelper}
          data={items}
          defaultColumns={clipUsersCloumns}
          paginationDetail={associatedChannelsPagination}
          paginationChange={onPaginationChange}
          showRowSelection={false}
          loading={loading}
        />
      )}
    </div>
  );
};

export default TabPanelContainer;
